import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import checkErrors from "Utils/InputValidator";
import STRINGS from "../Constants/Strings";
import VALIDATIONS from "../Constants/ValidationList";
import FIInformation from "../Constants/FIInformation";
import MODALMESSAGES from "../Constants/Messages";
import PopupModal from "../Components/Common/PopupModal/PopupModal";
import AppConstants from "../Constants/AppConstants";
import { S_ACCOUNT_ID, S_STAFF_ID } from "../Communication/Constants";

export function BranchRegister(props) {
  // Form state
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [hasMobile, setHasMobile] = useState(null);
  const [mobile, setMobile] = useState("");
  const [mobileOnHand, setMobileOnHand] = useState(null);
  const [homePhone, setHomePhone] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState({});
  const [showError, setShowError] = useState(false);
  const [errorText, setErrorText] = useState("");

  // Email validation function to allow only valid email characters
  const filterEmailCharacters = (value) =>
    // Allow letters, numbers, dots, hyphens, underscores, plus signs, and @ symbol
    value.replace(/[^a-zA-Z0-9@._+-]/g, "");

  // Mobile number validation function to allow only numeric characters
  const filterNumericCharacters = (value) =>
    // Allow only digits (0-9)
    value.replace(/[^0-9]/g, "");

  const verifyData = () => {
    let formIsValid = true;
    console.log(
      "Verifying data...",
      email,
      confirmEmail,
      hasMobile,
      mobile,
      mobileOnHand,
      homePhone
    );
    const emailRes = checkErrors(email, VALIDATIONS.REGISTRATION.email);
    console.log("emailRes", emailRes);
    if (emailRes && emailRes.length > 0) {
      setError((prev) => ({ ...prev, email: emailRes }));
      formIsValid = false;
    } else {
      const confirmEmailRes = checkErrors(
        confirmEmail,
        VALIDATIONS.REGISTRATION.email
      );
      console.log("confirmEmailRes", confirmEmailRes);
      if (email !== confirmEmail && confirmEmailRes.length === 0) {
        confirmEmailRes.push(STRINGS.REGISTRATION.ERROR.EMAIL_DO_NOT_MATCH);
      }
      if (confirmEmailRes.length > 0) {
        setError((prev) => ({ ...prev, confirmEmail: confirmEmailRes }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, confirmEmail: null }));
      }
    }

    if (hasMobile === null) {
      setError((prev) => ({
        ...prev,
        hasMobile: STRINGS.REGISTRATION.ERROR.HAS_MOBILE_REQUIRED,
      }));
      formIsValid = false;
    } else {
      setError((prev) => ({ ...prev, hasMobile: null }));
    }

    if (hasMobile === true) {
      if (mobileOnHand === null) {
        setError((prev) => ({
          ...prev,
          mobileOnHand: STRINGS.REGISTRATION.ERROR.MOBILE_ON_HAND,
        }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, mobileOnHand: null }));
      }

      const mobileRes = checkErrors(
        mobile,
        VALIDATIONS.REGISTRATION.BRANCH.MOBILE_NO
      );
      console.log("mobileRes", mobileRes, mobile);
      if (mobileRes && mobileRes.length > 0) {
        setError((prev) => ({ ...prev, mobile: mobileRes }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, mobile: null }));
      }
    } else if (hasMobile === false) {
      const homePhoneRes = checkErrors(
        homePhone,
        VALIDATIONS.REGISTRATION.BRANCH.HOME_PHONE
      );
      if (homePhoneRes && homePhoneRes.length > 0) {
        setError((prev) => ({ ...prev, homePhone: homePhoneRes }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, homePhone: null }));
      }
    } else {
      setError((prev) => ({ ...prev, mobile: null, homePhone: null }));
    }

    const termscondition = checkErrors(
      isChecked || "",
      VALIDATIONS.REGISTRATION.termscondition
    );

    if (termscondition && termscondition.length > 0) {
      setError((prev) => ({ ...prev, isChecked: termscondition }));
      formIsValid = false;
    } else {
      setError((prev) => ({ ...prev, isChecked: null }));
    }

    return formIsValid;
  };
  // Registration function to handle form submission
  const register = (e) => {
    e.preventDefault();

    // Reset error state before validation

    setError({});

    const {
      doCheckExistingUser,
      doRegistration,
      doVerification,
      bankingType,
    } = props;
    if (verifyData()) {
      // Handle form submission logic here
      console.log("Form submitted with:", {
        email,
        confirmEmail,
        hasMobile,
        mobile,
        mobileOnHand,
      });
      doCheckExistingUser(
        {
          credential: email,
          bankingType,
        },
        (response) => {
          console.log("Existing user check response:", response);
          if (response && response.data && response.data.existing) {
            setShowError(true);
            setErrorText(MODALMESSAGES.REGISTRATION.BRANCH.EXISTING_USER_ERROR);
          } else {
            // Proceed with registration if user does not exist
            doRegistration(
              {
                email,
                confirm: confirmEmail,
                hasMobile,
                msisdn: mobile ? `1${mobile}` : "",
                mobileOnHand,
                homePhone,
                otpTo: mobileOnHand ? "msisdn" : "email",
                bankingType: bankingType || AppConstants.BANKING_TYPE.PERSONAL,
                staffId: sessionStorage.getItem(S_STAFF_ID) || "",
              },
              (registrationResponse) => {
                console.log("Registration response:", registrationResponse);
                doVerification(registrationResponse.data);
                setShowError(false);
                setErrorText("");
                // Handle successful registration response here
              },
              (errorResponse) => {
                console.error("Registration error:", errorResponse);
                setShowError(true);
                setErrorText(
                  errorResponse.message ||
                    "An error occurred during registration."
                );
              }
            );
          }
        }
      );
    }
  };

  // Registration form (left column)
  const registrationForm = (
    <main className="[ register-container ]">
      <div className="[ form-title-register ]">
        PERSONAL MEMBER REGISTRATION
      </div>
      <div className="[ form-container ]">
        {/* Email field */}
        <div className="[ mb-3 ]">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            id="email"
            type="email"
            className="form-control"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => {
              setEmail(filterEmailCharacters(e.target.value));
              setError((prev) => ({ ...prev, email: null }));
            }}
            autoComplete="off"
          />
          <div className="[ error-msg ]">{error.email && error.email[0]}</div>
        </div>

        {/* Confirm email field */}
        <div className="[ mb-3 ]">
          <label htmlFor="confirmEmail" className="form-label">
            Confirm Email
          </label>
          <input
            id="confirmEmail"
            type="email"
            className="form-control"
            placeholder="Enter email address"
            value={confirmEmail}
            onChange={(e) => {
              setConfirmEmail(filterEmailCharacters(e.target.value));
              setError((prev) => ({ ...prev, confirmEmail: null }));
            }}
            autoComplete="off"
          />
          <div className="[ error-msg ]">
            {error.confirmEmail ? error.confirmEmail[0] : null}
          </div>
        </div>

        {/* Mobile disclosure drawer */}
        <div className="[ mb-3 ]">
          <div className="[ form-label ]">
            Does this customer have a mobile phone number?
          </div>
          <div className="[ row ] [ custom-radios ]">
            <div className="[ col-6 ]">
              <button
                type="button"
                id="hasMobile-yes"
                className={`${
                  hasMobile && typeof hasMobile === "boolean"
                    ? "[ btn custom-radio-selected ]"
                    : "[ btn custom-radio-unselected ]"
                }`}
                onClick={() => {
                  setHasMobile(true);
                  setError((prev) => ({ ...prev, hasMobile: null }));
                  setHomePhone(""); // Reset home phone if switching to mobile
                }}
              >
                Yes
              </button>
            </div>
            <div className="[ col-6 ]">
              <button
                type="button"
                id="hasMobile-no"
                className={`${
                  !hasMobile && typeof hasMobile === "boolean"
                    ? "[ btn custom-radio-selected ]"
                    : "[ btn custom-radio-unselected ]"
                }`}
                onClick={() => {
                  setHasMobile(false);
                  setError((prev) => ({ ...prev, hasMobile: null }));
                  setMobile(""); // Reset mobile if switching to home phone
                }}
              >
                No
              </button>
            </div>
          </div>
          {hasMobile === true && (
            <div className="[ drawer-content-container ]">
              <div className="[ info-title ]">Mobile Number</div>

              <div className="mb-3">
                <label htmlFor="mobile" className="form-label">
                  Enter Mobile no.
                </label>
                <input
                  id="mobile"
                  type="text"
                  className="form-control"
                  placeholder="Enter 10 digit mobile number"
                  aria-label="Enter mobile no."
                  value={mobile}
                  onChange={(e) => {
                    setMobile(filterNumericCharacters(e.target.value));
                    setError((prev) => ({ ...prev, mobile: null }));
                  }}
                  autoComplete="off"
                  maxLength={10}
                />
                <div className="[ error-msg ]">
                  {error.mobile ? error.mobile[0] : null}
                </div>
              </div>

              <div className="[ mb-3 ]">
                <div className="[ form-label ]">
                  Does this customer have their mobile on them right now?
                </div>
                <div className="[ row ] [ custom-radios ]">
                  <div className="[ col-6 ]">
                    <button
                      type="button"
                      id="mobileOnHand-yes"
                      className={`${
                        mobileOnHand && typeof mobileOnHand === "boolean"
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }`}
                      onClick={() => {
                        setMobileOnHand(true);
                        setError((prev) => ({ ...prev, mobileOnHand: null }));
                      }}
                    >
                      Yes
                    </button>
                  </div>
                  <div className="[ col-6 ]">
                    <button
                      type="button"
                      id="mobileOnHand-no"
                      className={`${
                        mobileOnHand === false &&
                        typeof mobileOnHand === "boolean"
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }`}
                      onClick={() => {
                        setMobileOnHand(false);
                        setError((prev) => ({ ...prev, mobileOnHand: null }));
                      }}
                    >
                      No
                    </button>
                  </div>
                </div>
                <div className="[ error-msg ]">{error.mobileOnHand}</div>
                {typeof mobileOnHand === "boolean" && (
                  <div className="mb-3">
                    {mobileOnHand && (
                      <div className="[ alert alert-info ]">
                        <p>
                          Inform the customer that in the next step a one time
                          verification code will be sent to their mobile. They
                          will report back this verification code to you for
                          them to be able to complete their smartOpen
                          registration.
                        </p>
                        <p>
                          Inform the customer that in the future, when they use
                          the smartOpen application for their first time, a one
                          time verification code will be sent to their email
                          address for them to set their own password.
                        </p>
                      </div>
                    )}
                    {!mobileOnHand && (
                      <div className="[ alert alert-info ]">
                        <p>
                          Inform the customer that in the future, when they use
                          the smartOpen application for their first time, a one
                          time verification code will be sent to their email
                          address for them to set their own password.
                        </p>
                        <p>
                          In the future, one time verification codes will be
                          sent to their mobile number for their convenience.
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {hasMobile === false && (
            <div className="[ drawer-content-container ]">
              <div className="[ info-title ]">Home Phone Number</div>
              <div className="mb-3">
                <label htmlFor="homePhone" className="form-label">
                  Enter home phone no.
                </label>
                <input
                  id="homePhone"
                  type="text"
                  className="form-control"
                  placeholder="Enter 10 digit home number"
                  aria-label="Enter home phone no."
                  value={homePhone}
                  onChange={(e) => {
                    setHomePhone(filterNumericCharacters(e.target.value));
                    setError((prev) => ({ ...prev, homePhone: null }));
                  }}
                  autoComplete="off"
                  maxLength={10}
                />
                <div className="[ error-msg ]">
                  <span>{error.homePhone ? error.homePhone[0] : null}</span>
                </div>
              </div>
              <div className="mb-3">
                <div className="[ alert alert-info ]">
                  <p>
                    Inform the customer that in the future, when they use the
                    smartOpen application for their first time, an email
                    containing a one time link will be sent to their email
                    address for them to be able to set their own password.
                  </p>
                  <p>
                    Any additional one time verification codes will also be sent
                    to their email address on file for their convenience.
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="[ error-msg ]">
            {error.hasMobile ? error.hasMobile : null}
          </div>
        </div>

        {/* Checkbox */}
        <div className="[ mb-3 ]">
          <div className="[ row ] [ align-items-center ]">
            <div className="[ col-12 ] [ d-flex align-items-center ]">
              <div className=" [ checkbox custom-control custom-checkbox ]">
                <input
                  type="checkbox"
                  defaultChecked={isChecked}
                  onChange={(e) => {
                    setIsChecked(e.target.checked);
                    setError((prev) => ({ ...prev, isChecked: null }));
                  }}
                  name="termscondition"
                  id="termsCheckbox"
                  className={
                    error.isChecked
                      ? "[ invalid-input ] [ custom-control-input ]"
                      : "[ custom-control-input ]"
                  }
                />
                <label
                  htmlFor="termsCheckbox"
                  className="[ custom-control-label ]"
                >
                  <span className="[ form-checkbox__text ]">
                    {STRINGS.REGISTRATION.FORM.TERMSLABEL1}
                    <a
                      href={FIInformation.FI_CONDITIONS}
                      className="[ text-primary ]"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {STRINGS.REGISTRATION.FORM.TERMSLABEL2}
                    </a>
                    {STRINGS.REGISTRATION.FORM.TERMSLABEL3}
                  </span>
                </label>
              </div>
            </div>

            <div className="[ error-msg ] [ col-12 ]">
              {error.isChecked ? MODALMESSAGES.REGISTRATION.TERMSERROR : ""}
            </div>
          </div>
        </div>
      </div>

      {/* Continue button */}
      <div className="[ mb-3 ]">
        <div className="[ row ]">
          <div className="[ col-xl-6 ] [ offset-xl-3 ]">
            <button
              type="submit"
              className="[ submit-btn btn ] [ w-100 ]"
              onClick={register}
            >
              {STRINGS.REGISTRATION.FORM.REGISTRATIONBTN}
            </button>
          </div>
        </div>
      </div>
    </main>
  );

  // Info panel (center column)
  const infoPanel = (
    <aside
      class="branch-widget branch-widget--registration"
      aria-labelledby="registration-instructions-title"
    >
      <div class="branch-widget__subheader row">
        <div class="[ info-title ]" id="registration-instructions-title">
          Register your customer
        </div>
      </div>
      <div class="branch-widget__body row">
        <div class="branch-widget__body-text col-12">
          <ul>
            <li>Register the customer's smartOpen profile.</li>
            <li>
              Inform the customer they can begin, add to, continue, or complete
              product and account applications online anytime, from anywher
              whether that is in branch with a staff member, or on the go.
            </li>
            <li>
              Explain that application progress is saved and can be continued or
              completed across channels by the customer or a staff member, in
              any order.
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );

  // Personal cart (right column)
  const cartPanel = (
    <div class="[ vault-container ]">
      <div class="[ vault-container__inner-container ]">
        <div class="[ vault-header__container ]">
          <h4 class="[ form-subtitle ]">
            <i class="[ fas fa-shopping-cart ]"></i>
            PERSONAL CART
            <button type="button" class="[ close ]">
              <span aria-hidden="true">x</span>
              <span class="[ sr-only ]">Close</span>
            </button>
          </h4>
        </div>
        <div class="[ text-center ] [ p-5 ] [ mt-5 ]">
          <div class="[ empty-cart ]">
            <p>“0” item(s) in your cart</p>
            <p>Add financial products from the marketplace to your cart.</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="[ branch-wrapper ]">
      {showError && (
        <PopupModal
          type={AppConstants.MODALTYPE.FAILURE}
          title={errorText}
          toggleModal={() => setShowError(false)}
          showModal={showError}
          btnText={STRINGS.POPUPMODAL.OKBUTTON}
        />
      )}
      <div className="[ container ] [ pb-3 ] [ main-container ]">
        <div className="[ row ] [ main-container__body ]">
          <div className="[ col-xl-6 col-lg-12 order-2 order-xl-1 ] [ main-container__body__left-column ][ tri-column ]">
            {registrationForm}
          </div>
          <div className="[ col-xl-3 col-lg-12 order-1 order-xl-2 ] [ main-container__body__middle-column ]">
            {infoPanel}
          </div>
          <div className="[ col-xl-3 col-lg-12 order-3 order-xl-3 ] [ d-none d-xl-block ] [ main-container__body__right-column ]">
            {cartPanel}
          </div>
        </div>
      </div>
    </div>
  );
}

BranchRegister.propTypes = {
  doCheckExistingUser: PropTypes.func.isRequired,
  doRegistration: PropTypes.func.isRequired,
  doVerification: PropTypes.func.isRequired,
  bankingType: PropTypes.string, // Specify the correct PropTypes type if known
};

BranchRegister.defaultProps = {
  bankingType: AppConstants.BANKING_TYPE.PERSONAL, // Default value for bankingType
};

export default BranchRegister;
